
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { PageItemProps } from ".";
import { loading, find } from "store/page";

interface ApiPageFindByIdInputProps {
    id: number;
    count?: boolean;
}

type ApiPageFindOutputProps = OutputBaseProps<{ item: PageItemProps; }, ApiPageFindByIdInputProps>

export const apiPageFindById = async (data: ApiPageFindByIdInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiPageFindOutputProps>(`/api/page/${data.id}`, { params: { count: data.count } }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(find({ data: res.data.item }));
    }
    return res;
};


interface ApiPageFindByUrlInputProps {
    url: string;
}

export const apiPageFindByUrl = async (data: ApiPageFindByUrlInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiPageFindOutputProps>(`/api/page/url`, { params: { url: encodeURIComponent(`${data.url}`) } }))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(find({ data: res.data.item }));
    }
    return res;
};